import crypto from "crypto";
const DIFFICULTY = 3;

export function generateNextBlock(previousBlock, data) {
  const index = previousBlock.index + 1;
  const previousHash = previousBlock.hash;
  let nonce = 0;
  let hash;
  let timestamp;
  // proof-of-work
  do {
    timestamp = new Date().getTime();
    nonce = nonce + 1;
    hash = calculateHash(index, previousHash, timestamp, data, nonce);
  } while (!isValidHashDifficulty(hash));

  return {
    index: index,
    previousHash: previousBlock.hash,
    timestamp: timestamp,
    data: data,
    hash: hash,
    nonce: nonce
  };
}

export function calculateHash(index, previousHash, timestamp, data, nonce) {
  const blockData =
    index + previousHash + timestamp + data + nonce;

  return crypto
    .createHash("sha256")
    .update(blockData)
    .digest("hex");
}

export function isValidHashDifficulty(hash) {
  for (var i = 0, b = hash.length; i < b; i++) {
    if (hash[i] !== "0") {
      break;
    }
  }
  return i >= DIFFICULTY;
}

export function isValidNextBlock(nextBlock, previousBlock) {
  if (previousBlock.index + 1 !== nextBlock.index) {
    return false
  } else if (previousBlock.hash !== nextBlock.previousHash) {
    return false
  } else if (!isValidHashDifficulty(nextBlock.previousHash)) {
    return false
  } else if (!isValidHashDifficulty(nextBlock.hash)) {
    return false;
  }
  return true;
}

export function isValidChain(chain, genesisBlock) {
  if (JSON.stringify(chain[0]) !== JSON.stringify(genesisBlock)) {
    return false
  }

  const tempBlocks = [genesisBlock]
  for (let i = 1; i < chain.length; i = i + 1) {
    if (isValidNextBlock(chain[i], tempBlocks[i - 1])) {
      tempBlocks.push(chain[i]);
    } else {
      return false
    }
  }
  return true
}


// WEBPACK FOOTER //
// ./src/Mine/util.js